import $ from "jquery";

$(() => window.init_customization_defaults());

window.init_customization_defaults = function () {

    $('#all_current_spins_in_all_projects').on('change', function () {
        if ($(this).is(':checked')) {
            $('#all_current_spins_in_this_project').prop('checked', true);
        }
    });

    $('#all_future_spins_in_all_projects').on('change', function () {
        if ($(this).is(':checked')) {
            $('#all_future_spins_in_this_project').prop('checked', true);
        }
    });
};
